import { render } from "./ServiceWestern.vue?vue&type=template&id=68f5d37a"
import script from "./ServiceWestern.vue?vue&type=script&lang=js"
export * from "./ServiceWestern.vue?vue&type=script&lang=js"
script.render = render

export default script